import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { CallRecordsDatabaseResource, DatabaseImportResponse } from '../../resources/import.abstract.resource';
import { BreadcrumbsService } from '../../../shared/breadcrumbs/breadcrumbs.service';
import { ImportAbstractDirective, ImportFileTypes, ImportTypes } from '../import.abstract.directive';
import { Observable } from 'rxjs';

@Component({
  selector: 'ziro-import-call-records',
  templateUrl: '../import.abstract.component.html',
  styleUrls: ['../../admin-page.scss', '../import.abstract.component.scss'],
  standalone: false,
})
export class ImportCallRecordsComponent extends ImportAbstractDirective implements OnInit, OnDestroy {
  protected breadcrumbsService = inject(BreadcrumbsService);
  private callRecordsDatabaseResource = inject(CallRecordsDatabaseResource);

  warningText = 'tkey;pages.admin.cdr.import.warning.text';
  warningTextPreamble = 'tkey;pages.admin.cdr.import.preamble.text';

  constructor() {
    super();

    this.breadcrumbsService.updateBreadcrumbs([{ label: 'tkey;pages.admin.cdr.import.header' }]);
    this.importFileType = ImportFileTypes.CDR;
  }

  ngOnDestroy(): void {
    this.breadcrumbsService.clearBreadcrumbs();
  }

  requestImport = (): Observable<DatabaseImportResponse> => {
    this.formData.importFrom = ImportTypes.FILE;
    const request = this.getImportRequest();

    return this.callRecordsDatabaseResource.post(request);
  };
}
